<template>
  <div class="box__buttons">
    <div v-if="!isBoxForVictory" class="box__count">
      <button class="box__count__prev" @click="changeBoxCount(prevCountIndex)">
        <i class="icon icon-arrow-small"></i>
      </button>
      <div class="box__count__active">
        <span>{{ count_list[count_index] }}</span>
      </div>
      <button class="box__count__next" @click="changeBoxCount(nextCountIndex)">
        <i class="icon icon-arrow-small"></i>
      </button>
    </div>
    <ProgressButton :extraClass="getButtonClass" :duration="0.7" @progressEnd="openBox">
      <span>{{ $t("common.open") }}</span>
    </ProgressButton>
  </div>
</template>
<script>
import ProgressButton from "@libs/progress_button/progress_button_lite";
import { mapGetters } from "vuex";
export default {
  name: "ShopItemBuyButtons",
  components: {
    ProgressButton,
  },
  props: {
    boxContent: Object,
    isBoxForVictory: Boolean,
    currentCurrency: String,
    victoryCurrency: String,
  },
  data() {
    return {
      count_index: 0,
      count_list: [1, 2, 3, 4, 5, 10],
      show_list: false,
      button_loader: false,
      currency: {
        hard: 1,
        soft: 2,
        victory: 3,
        victory_vip: 4,
      },
    };
  },
  computed: {
    ...mapGetters("global", ["userIsTrial"]),
    ...mapGetters("wallets", ["getWalletsState"]),

    isMemberBox() {
      return !this.boxContent.conditions.status.includes("trial");
    },
    getButtonClass() {
      return ["box__buy-button gtm-button", { "button--loader": this.button_loader }];
    },
    getCurrentCurrency() {
      return this.isBoxForVictory ? this.victoryCurrency : this.currentCurrency;
    },
    getCurrencyAmount() {
      return this.boxContent.conditions.currencies.filter(
        item => item.currency === this.getCurrentCurrency
      )[0].amount;
    },
    getUserMoney() {
      return this.getWalletsState[this.getCurrentCurrency];
    },
    prevCountIndex() {
      return this.count_index === 0 ? this.count_list.length - 1 : this.count_index - 1;
    },
    nextCountIndex() {
      return this.count_index === this.count_list.length - 1 ? 0 : this.count_index + 1;
    },
  },
  methods: {
    changeBoxCount(index) {
      this.$emit("countBox", this.count_list[index]);
      this.count_index = index;
    },

    openBox() {
      this.$emit("openBoxGTM", this.getCurrentCurrency);

      if (this.userIsTrial && this.isMemberBox) {
        this.$notify({
          group: "default",
          type: "error",
          text: this.$t("notifications.error.access"),
        });
        return false;
      }

      if (this.getCurrencyAmount * this.count_list[this.count_index] > this.getUserMoney) {
        this.$notify({
          group: "default",
          type: "error",
          text: this.$t(`notifications.error.currency_${this.getCurrentCurrency}`),
        });
        return false;
      }

      this.button_loader = true;

      const currency_type = this.isBoxForVictory
        ? this.currency[this.victoryCurrency]
        : this.currency[this.currentCurrency];

      this.$store
        .dispatch("shop/openShopItem", {
          count: this.count_list[this.count_index],
          id: this.boxContent.id,
          currency: currency_type,
        })
        .then(() => {
          this.$store.commit("shop/writeIsBoxRepeteable", this.boxContent.is_repeatable);
          this.$store.commit("global/writeCurScreen", "loot");

          this.$store.dispatch("wallets/getWalletsData").then(() => {
            this.button_loader = false;
            this.$store.commit("global/writeCurScreen", "loot");
          });
        });
    },
  },
};
</script>
